module.exports = __webpack_public_path__ + "img/pr-16.38c008ae.png";